import { SpinnerModalComponent } from './../spinner/spinner-modal.component';
import { UntypedFormGroup } from '@angular/forms';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, Inject } from '@angular/core';
import { SsFamilleModel } from 'src/app/shared/models/simple-types/ss-famille.model';
import { SsFamilleService } from 'src/app/shared/services/simple/ss-famille.service';
import { ModalAddActiviteComponent } from '../modal-add-activite/modal-add-activite.component';

export interface DialogData {
  form: UntypedFormGroup;
  ssFamilles: SsFamilleModel[];
  result: boolean;
}

@Component({
  selector: 'app-modal-add-ss-famille',
  templateUrl: './modal-add-ss-famille.component.html',
  styleUrls: ['./modal-add-ss-famille.component.scss']
})
export class ModalAddSsFamilleComponent implements OnInit {

  form: UntypedFormGroup;
  constructor(public dialog: MatDialog
            , public dialogRef: MatDialogRef<ModalAddActiviteComponent>
            , @Inject(MAT_DIALOG_DATA) public data: DialogData
            , private toastr: ToastrService
            , private ssFamilleService: SsFamilleService) {
             }

    ngOnInit(): void {
      this.form = this.data.form;
    }

    onModalCancel(): void {
      this.data.result = false;
      this.dialogRef.close(false);
    }

    onModalConfirm(): void {
      if (this.form.valid) {
        const ssFamille = this.form.getRawValue();
        // Création
        if (!this.form.get('id').value){
          const dialogRef = this.dialog.open(SpinnerModalComponent);
            this.ssFamilleService.save(ssFamille).subscribe((a: SsFamilleModel) => {
              this.toastr.success('', 'Création de la sous famille ' + a.code + ' réussie');
              this.dialogRef.close(a);
              dialogRef.close();
            }, (error) => {
              this.dialogRef.close(false);
              dialogRef.close();
            });
        }else { // Modification
          const dialogRef = this.dialog.open(SpinnerModalComponent);
          this.ssFamilleService.update(ssFamille.id, ssFamille).subscribe((a: SsFamilleModel) => {
            this.toastr.success('', 'Modification de la sous famille ' + a.code + ' réussie');
            this.dialogRef.close(a);
            dialogRef.close();
          }, (error) => {
            this.dialogRef.close(false);
            dialogRef.close();
          });
        }
      } else {
        this.displayErrors();
      }
   }

   displayErrors(): void {
    for (const index in this.form.controls) {
      if (index && (this.form.controls[index].hasError('required') || this.form.controls[index].hasError('max'))) {
        this.form.controls[index].markAsTouched();
      }
    }
  }
}



